/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2018 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H217483 on 3/13/2019.
 */
import React from 'react'
import connect from "react-redux/es/connect/connect"
import {bindActionCreators} from "redux"
import * as AssetActions from "./AssetActions"
import {Button, Grid, Input, InputLabel} from "@scuf/common";
import {getFieldErrorMessage} from "../../utils/Helpers";
import {FormattedMessage, injectIntl} from "react-intl";
import TreeSelector from "../../common/TreeSelector";
import {assetModel, assetModelHda} from "../../model/Asset";
import {showNotification} from "../../common/ToastNotification";
import Loader from "../../common/Loader";
import AssetExistNotification from "../common/AssetExistNotification";
import {userHasActivity} from "../../security/SecurityUtils";
import {ACTIVITY_TYPES} from "../../security/SecurityConst";
import VariantSelectors from "./VariantSelectors";
import {fetchLdiNamesAndIds} from "../../api/AppConfigs";
import LdiSelector from "../../common/LdiSelector";

class AssetFormSimple extends React.Component {
    constructor(props) {
        super(props)

        const {intl, userProfile} = this.props

        this.state = {
            errors: [],
            existingAsset: {
                readAccess: false,
                asset: {},
            },
            selectedVariants: new Map(),
            hdaFleetId: null,
            engineType: null,
            engineModel: null,
            configuration: null,
            platform: null,
            ldiNamesAndIds: null,
            selectedLdiForHDR: -1,
        }

        this.assetModel = userHasActivity(userProfile, ACTIVITY_TYPES.HDA_FUNCTIONALITIES) ? assetModelHda(intl) : assetModel(intl)

        this.setAssetAttribute = this.setAssetAttribute.bind(this)
        this.submitAsset = this.submitAsset.bind(this)
        this.cancelClicked = this.cancelClicked.bind(this)
        this.fetchVariants = this.fetchVariants.bind(this)
        this.fetchLdiNamesAndIds = this.fetchLdiNamesAndIds.bind(this)
    }

    componentDidMount() {
        const {userProfile} = this.props
        this.props.AssetActions.clearState();
        if(!userHasActivity(userProfile, ACTIVITY_TYPES.HDA_FUNCTIONALITIES)) {
            this.fetchFleets()
        }
        if (this.props.initNameValue != null) {
            this.setAssetAttribute('name', this.props.initNameValue)
        }
        this.fetchVariants()
        this.fetchLdiNamesAndIds()
    }

    fetchLdiNamesAndIds() {
        const me = this
        fetchLdiNamesAndIds().then(function (response) {
            if (response.length === 1) {
                me.setState({ldiNamesAndIds: response, selectedLdiForHDR: response[0].value})
            }
            else {
                me.setState({ldiNamesAndIds: response})
            }
        });
    }

    fetchFleets() {
        this.props.AssetActions.fetchFleetsHierarchy()
    }

    setAssetAttribute(key, value) {
        this.props.AssetActions.setAssetAttribute(key, value)
    }

    fetchVariants() {
        this.props.AssetActions.fetchVariants();
    }

    submitAsset() {
        const {asset, intl, userProfile} = this.props
        const variantArray = [];
        let ldiId;
        for (const [key, value] of this.state.selectedVariants) {
            ldiId = value.ldiId
            const variantId = value.id
            variantArray.push(variantId);
        }

        if (!userHasActivity(userProfile, ACTIVITY_TYPES.HDA_FUNCTIONALITIES)) {
            ldiId = this.state.selectedLdiForHDR === -1 ? null : this.state.selectedLdiForHDR
        }

        const myAsset = {
            id: asset.id,
            name: asset.name,
            fleetId: userHasActivity(userProfile, ACTIVITY_TYPES.HDA_FUNCTIONALITIES) ? 1 : asset.fleetId,
            variants: variantArray,
            engineType: this.state.engineType,
            engineModel: this.state.engineModel,
            configuration: this.state.configuration,
            platform: this.state.platform,
            ldiId: ldiId,
        }

        this.assetModel.validate(myAsset, {abortEarly:false}).then(() => {
            this.setState({errors: []})
            this.props.AssetActions.createAsset(myAsset, userHasActivity(userProfile, ACTIVITY_TYPES.HDA_FUNCTIONALITIES)).then((newAsset) => {
                showNotification({title: intl.formatMessage({id: 'admin.asset.created'}, {name: newAsset.name})})
                this.props.AssetActions.clearState()
                if (this.props.afterCreate) {
                    this.props.afterCreate(newAsset)
                }
            }).catch(err => {
                if (err.errorKey === 'business.exception.ASSET_NAME_ALREADY_EXISTS') {
                    this.setState({
                        errors: [{
                            path: 'name',
                            message: intl.formatMessage({id: 'admin.asset.ASSET_NAME_ALREADY_EXISTS'}, {name: asset.name}),
                        }],
                    })
                    if (err.params && err.params.length === 2) {
                        this.setState({existingAsset: {readAccess: err.params[0], asset: err.params[1]}});
                    }
                }
            })
        }).catch(err => {
            this.setState({
                errors: err.inner.map(i => {
                    return {path: i.path, message: i.errors}
                }),
            })
        })
    }

    cancelClicked() {
        this.props.AssetActions.clearState()
        if (this.props.onCancel) {
            this.props.onCancel()
        }
    }

    getFleetHierarchyOptions() {
        const {fleetsHierarchy} = this.props
        return fleetsHierarchy.map(f => {
            return this.getHierarchyItem(f)
        })
    }

    getHierarchyItem(item) {
        let subItems = []
        const hasSubfleets = item.subFleets && item.subFleets.length > 0
        if (hasSubfleets) {
            subItems = item.subFleets.map(f => {
                return this.getHierarchyItem(f)
            })
        }
        return {
            id: item.id,
            name: item.name,
            selectable: !hasSubfleets,
            items: subItems,
        }
    }

    getErrorMessage(fields) {
        const errs = []
        fields.forEach(field => errs.push(this.state.errors.find(err => err.path === field)))

        return errs.filter(err => err != null).reduce(
            (composeMsg, err) => composeMsg ? composeMsg + "<br/>" + err.message : err.message, null)
    }

    render() {
        const {asset, intl, variants, userProfile} = this.props

        let hierarchy;
        if (!userHasActivity(userProfile, ACTIVITY_TYPES.HDA_FUNCTIONALITIES)) {
            hierarchy = this.getFleetHierarchyOptions()
        }

        // If is normal HDR environment (not HDA) is needed to pick the LDI if multiple available, before create the asset
        let ldiSelector = null
        if (this.state.ldiNamesAndIds != null && this.state.ldiNamesAndIds.length > 1) {
            ldiSelector =
                <LdiSelector
                    ldiNamesAndIds={this.state.ldiNamesAndIds}
                    selectedLdiForHDR={this.state.selectedLdiForHDR}
                    onLdiChange={(data) => {
                        this.setState({
                            selectedLdiForHDR: data,
                        });
                    }}
                    getErrorMessage={(data) => this.getErrorMessage(data)}
                />
        }

        const me = this;

        if (userHasActivity(userProfile, ACTIVITY_TYPES.HDA_FUNCTIONALITIES)) {
            return (
                <React.Fragment>
                    <Grid>
                        <Grid.Row>
                            <Grid.Column width={12}>
                                <h2><FormattedMessage id="admin.asset.create.title"/></h2>
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Column width={12}>
                                <div className="below-text-none">
                                    <Input label={intl.formatMessage({id: "admin.asset.edit.name"})}
                                           value={asset.name}
                                           onChange={value => this.setAssetAttribute('name', value)}
                                           fluid
                                           error={getFieldErrorMessage('name', this.state.errors)}
                                    />
                                </div>
                            </Grid.Column>
                        </Grid.Row>
                        {
                            this.state.existingAsset.asset.name == null ?
                                null
                                :
                                <Grid.Row>
                                    <Grid.Column width={12}>
                                        <AssetExistNotification existingAsset={this.state.existingAsset} />
                                    </Grid.Column>
                                </Grid.Row>
                        }
                        <VariantSelectors
                            readAccess={this.state.readAccess}
                            variants={variants}
                            selectedVariants={this.state.selectedVariants}
                            onVariantChange={(data, variantType) => {
                                const newSelectedVariants = new Map(this.state.selectedVariants)
                                newSelectedVariants.set(variantType, variants.get(variantType).find(function (element) {
                                    return element.id === data;
                                }))
                                this.setState({selectedVariants: newSelectedVariants})
                            }}
                            engineType={me.state.engineType}
                            engineModel={me.state.engineModel}
                            configuration={me.state.configuration}
                            platform={me.state.platform}
                            onEngineTypeChange={(data) => {
                                this.setState({
                                    engineType: data,
                                    engineModel: null,
                                    configuration: null,
                                    platform: null,
                                })
                            }}
                            onEngineModelChange={(data) => {
                                this.setState({
                                    engineModel: data,
                                    configuration: null,
                                    platform: null,
                                })
                            }}
                            onConfigurationChange={(data) => {
                                this.setState({
                                    configuration: data,
                                    platform: null,
                                })
                            }}
                            onPlatformChange={(data, variantType) => {
                                const newSelectedVariants = new Map()
                                // HDA can have just 1 variant per Asset (there doesn't matter on Variant types)
                                newSelectedVariants.set(variantType, (variants.get(variantType)).find(v =>
                                    v.engineType === me.state.engineType &&
                                    v.engineModel === me.state.engineModel &&
                                    (v.configuration == null || v.configuration === me.state.configuration) &&
                                    v.platform === data
                                ))
                                this.setState({
                                    selectedVariants: newSelectedVariants,
                                    platform: data,
                                });
                            }}
                            getErrorMessage={(data) => this.getErrorMessage(data)}
                        />
                        <Grid.Row>
                            <Grid.Column width={12}>
                                <div className="align-right variants">
                                    {this.props.onCancel ?
                                        <Button className="mobile-max-width-button" id="asset-cancel" onClick={this.cancelClicked} type="secondary"><FormattedMessage
                                            id="admin.asset.cancel"/></Button>
                                        :
                                        null
                                    }
                                    <Button className="mobile-max-width-button" id="asset-submit" onClick={this.submitAsset}><FormattedMessage id="admin.asset.submit"/></Button>
                                </div>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                    <Loader loading={this.props.loading}/>
                </React.Fragment>
            )
        }

        return (
            <React.Fragment>
                <Grid>
                    <Grid.Row>
                        <Grid.Column width={12}>
                            <h2><FormattedMessage id="admin.asset.create.title"/></h2>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column width={12}>
                            <div className="below-text-none">
                                <Input label={intl.formatMessage({id: "admin.asset.edit.name"})}
                                       value={asset.name}
                                       onChange={value => this.setAssetAttribute('name', value)}
                                       fluid
                                       error={getFieldErrorMessage('name', this.state.errors)}
                                />
                            </div>
                        </Grid.Column>
                    </Grid.Row>
                    {
                        this.state.existingAsset.asset.name == null ?
                            null
                            :
                            <Grid.Row>
                                <Grid.Column width={12}>
                                    <AssetExistNotification existingAsset={this.state.existingAsset} />
                                </Grid.Column>
                            </Grid.Row>
                    }
                    <React.Fragment>
                        <Grid.Row>
                            <Grid.Column width={12}>
                                <div className="ldi-selector">
                                    {ldiSelector}
                                </div>
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Column width={12}>
                                <div className="fleet-dropdown-modal">
                                    <InputLabel label={intl.formatMessage({id:"admin.asset.fleet"})}/>
                                    <TreeSelector
                                        singleSelection={true}
                                        selectionChanged={(id) => {
                                            if (id.length > 0) {
                                                this.setAssetAttribute('fleetId', id[0])
                                            } else {
                                                this.setAssetAttribute('fleetId', null)
                                            }
                                        }}
                                        tree={hierarchy}
                                        selectedItems={asset.fleetId ? [asset.fleetId] : []}
                                        error={getFieldErrorMessage('fleetId', this.state.errors)}
                                        placeholder={intl.formatMessage({id: "admin.asset.fleet.select"})}
                                        asDropdown={true}
                                    />
                                </div>
                            </Grid.Column>
                        </Grid.Row>
                    </React.Fragment>
                    <Grid.Row>
                        <Grid.Column width={12}>
                            <div className="align-right no-variants">
                                {this.props.onCancel ?
                                    <Button className="mobile-max-width-button" id="asset-cancel" onClick={this.cancelClicked} type="secondary"><FormattedMessage
                                        id="admin.asset.cancel"/></Button>
                                    :
                                    null
                                }
                                <Button className="mobile-max-width-button" id="asset-submit" onClick={this.submitAsset}><FormattedMessage id="admin.asset.submit"/></Button>
                            </div>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
                <Loader loading={this.props.loading}/>
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        asset: state.assetReducer.asset,
        loading: state.assetReducer.loading,
        profile: !state.security ? null : state.security.userProfile,
        fleetsHierarchy: state.assetReducer.fleetsHierarchy,
        variants: state.assetReducer.variants,
        userProfile: state.security.userProfile,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        AssetActions: bindActionCreators(AssetActions, dispatch),
    }
}


export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(AssetFormSimple))